import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/compress-pdf/page.tsx");
